//
// Copyright 2021 DXOS.org
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=js"
// @generated from file dxos/mesh/presence.proto (package dxos.mesh.presence, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { PublicKey } from "../keys_pb.js";
import { file_dxos_keys } from "../keys_pb.js";
import { file_google_protobuf_any } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file dxos/mesh/presence.proto.
 */
export const file_dxos_mesh_presence: GenFile = /*@__PURE__*/
  fileDesc("ChhkeG9zL21lc2gvcHJlc2VuY2UucHJvdG8SEmR4b3MubWVzaC5wcmVzZW5jZSKaAQoJUGVlclN0YXRlEikKC2Nvbm5lY3Rpb25zGAEgAygLMhQuZHhvcy5rZXlzLlB1YmxpY0tleRIqCgxpZGVudGl0eV9rZXkYAiABKAsyFC5keG9zLmtleXMuUHVibGljS2V5EioKB3BlZXJfaWQYAyABKAsyFC5keG9zLmtleXMuUHVibGljS2V5SACIAQFCCgoIX3BlZXJfaWRiBnByb3RvMw", [file_dxos_keys, file_google_protobuf_any]);

/**
 * @generated from message dxos.mesh.presence.PeerState
 */
export type PeerState = Message<"dxos.mesh.presence.PeerState"> & {
  /**
   * / Will be used to build network graph
   *
   * @generated from field: repeated dxos.keys.PublicKey connections = 1;
   */
  connections: PublicKey[];

  /**
   * TODO(mykola): Remove once IdentityKey can be obtained from DeviceKey.
   *
   * @generated from field: dxos.keys.PublicKey identity_key = 2;
   */
  identityKey?: PublicKey;

  /**
   * / Omitted when sent over the network.
   *
   * @generated from field: optional dxos.keys.PublicKey peer_id = 3;
   */
  peerId?: PublicKey;
};

/**
 * Describes the message dxos.mesh.presence.PeerState.
 * Use `create(PeerStateSchema)` to create a new message.
 */
export const PeerStateSchema: GenMessage<PeerState> = /*@__PURE__*/
  messageDesc(file_dxos_mesh_presence, 0);

